import "./style.css";
import Jumbotron from "../../Jumbotron/Jumbotron";
import NavBar from "../../NavBar/NavBar";
import Login from "../../Login/Login";
import Events_JSON from "./Events.json";
import EventPost from "../../EventPost/EventPost";
import { useEffect, useState } from "react";
const FrontPage = ({ children }) => {
  const [presentation_items, set_presentation] = useState([
    "best friend",
    "community",
  ]);
  useEffect(() => {
    setTimeout(() => {
      const events_labels = ["best friend", "community."];
      const market_labels = ["business", "market."];
      set_presentation(
        presentation_items[0] === events_labels[0]
          ? market_labels
          : events_labels
      );
    }, 3000);
  });
  const EventsJSX = Events_JSON.Events.map(
    ({ title, description, attendees, tags, image, emoji }, i) => {
      return (
        <EventPost
          title={title}
          description={description}
          attendees={attendees}
          image={image}
          tags={tags}
          emoji={emoji}
          height="19rem"
          width="15rem"
          order={i}
          type={"event"}
        />
      );
    }
  );
  const MarketplaceJSX = Events_JSON.Market.map(
    ({ title, description, attendees, tags, image, emoji }, i) => {
      return (
        <EventPost
          title={title}
          description={description}
          attendees={attendees}
          image={image}
          tags={tags}
          emoji={emoji}
          height="19rem"
          width="15rem"
          order={i}
          type={"item"}
        />
      );
    }
  );
  return (
    <div id="website_container">
      <NavBar />
      <div
        style={{
          display: "flex",
          width: "100w",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: "2rem",
          marginBottom: "15vh",
        }}
      >
        <Jumbotron
          height="66vh"
          width="45vw"
          title="Welcome to Boomerang!"
          description={"A student's " + presentation_items[0]}
          image_link={""}
        >
          <img style={{ height: "12rem", width: "12rem" }} src="/logo.svg" />
        </Jumbotron>
        <Login emphasis={presentation_items[1]} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "opacity(20%)",
        }}
        id="Events_Header"
        className="Header"
      >
        <h1 style={{ zIndex: "2" }}>Events</h1>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            opacity: "1",
            filter: "brightness(80%)",
            backdropFilter: "blur(3px)",
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            overflow: "hidden",

            backgroundImage: `url("https://i.pinimg.com/originals/88/8e/6f/888e6fa5dc0b8c88d69f1998f57248c0.jpg")`,
          }}
        ></div>
      </div>
      <div className="Events_Slide">{EventsJSX}</div>
      <div
        className="Header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "opacity(20%)",
        }}
        id="Marketplace_Header"
      >
        <h1 style={{ zIndex: 2 }}>Marketplace</h1>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            opacity: "1",
            filter: "brightness(80%)",
            backdropFilter: "blur(3px)",
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            overflow: "hidden",

            backgroundImage: `url("https://www.visitconcordca.com/imager/s3-us-west-1_amazonaws_com/concord-2018/craft/blog/SunvalleyMall-Entrance_77a996cadb6acd997fdd4924ba23cc85.jpg")`,
          }}
        ></div>
      </div>
      <div className="Events_Slide">{MarketplaceJSX}</div>
      <div
        className="Header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "opacity(20%)",
        }}
        id="About_Us_Header"
      >
        <h1 style={{ zIndex: 2 }}>About Us</h1>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            opacity: "1",
            filter: "brightness(80%)",
            backdropFilter: "blur(3px)",
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            overflow: "hidden",

            backgroundImage: `url("https://swall.teahub.io/photos/small/67-673750_students-wallpapers-c347o4h-campus-happy-college-students.jpg")`,
          }}
        ></div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Jumbotron
          height="60vh"
          width="30vw"
          style={{
            margin: "3vh",
            animation: "none",
            backgroundImage: `linear-gradient(0deg, rgba(0,0,0,0) 41%, #ff2b4f 68%), url("https://skillsacademy.tech/wp-content/uploads/2021/06/CSEC-Information-Technology-Private-Classes-2.gif")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          title="Student Led"
          description={"The site is made by students for students."}
        />
        <Jumbotron
          height="60vh"
          width="30vw"
          style={{
            margin: "3vh",
            animation: "none",
            backgroundImage: `linear-gradient(0deg, rgba(0,0,0,0) 41%, #378ec7 68%), url("https://media2.giphy.com/media/YjtJu4AerQYmYbET3J/giphy.gif")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          title="Driven by Passion"
          description={"We emphasize student well-being."}
        />
        <Jumbotron
          height="60vh"
          width="30vw"
          style={{
            margin: "3vh",
            animation: "none",
            backgroundImage: `linear-gradient(0deg, rgba(0,0,0,0) 41%, #b942f5 68%), url("https://camo.githubusercontent.com/3a031d730ae294dac1b2309b6780c5cae508ac876856cc546eb65af12014b216/68747470733a2f2f72656d616b656c6561726e696e672e6f72672f77702d636f6e74656e742f75706c6f6164732f323032302f30312f3132322e676966")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          title="Project Bracket"
          description={
            "We are passionate group of computer scientists, creators, and leaders!"
          }
        />
      </div>
      <div
        className="Header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "opacity(20%)",
        }}
        id="Contact_Us_Header"
      >
        <h1 style={{ zIndex: 2 }}>Contact Us</h1>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            opacity: "1",
            filter: "brightness(80%)",
            backdropFilter: "blur(3px)",
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            overflow: "hidden",

            backgroundImage: `url("https://images.unsplash.com/photo-1560268744-aaab797cdfc4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8dGVsZXBob25lfGVufDB8fDB8fA%3D%3D&w=1000&q=80")`,
          }}
        ></div>
      </div>
      <div style={{ display: "flex" }}>
        <Jumbotron
          height="60vh"
          width="30vw"
          style={{
            margin: "3vh",
            animation: "none",
            backgroundImage: `url("https://i.redd.it/y6rc2sm425051.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          title="Project Bracket"
          description={""}
        />{" "}
        <Jumbotron
          height="60vh"
          width="30vw"
          style={{
            margin: "3vh",
            animation: "none",
            backgroundImage: `url("https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwosRG2XeuzT31Sfl7aNjyJwWp2me03dzHVw&usqp=CAU")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          title="Project Bracket"
          description={""}
        />{" "}
        <Jumbotron
          height="60vh"
          width="30vw"
          style={{
            margin: "3vh",
            animation: "none",
            backgroundImage: `url("/official_logo.png")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          title="Team Boomerang"
          description={""}
        />
      </div>
    </div>
  );
};

export default FrontPage;
